import useEmployee from "./useEmployee";

export function useHasGivenConsent() {
  const { employeeData } = useEmployee();

  const isGivenConsent = employeeData?.isConsentGiven;

  return isGivenConsent;
}
